export default __webpack_public_path__ + "static/media/P3 ID_ljudläggare_mixare.9c53177c.jpeg";